var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { LinearProgress, Typography, Box } from '@mui/material';
var LinearProgressWithLabel = function (props) {
    var label = props.label, otherProps = __rest(props, ["label"]);
    return (React.createElement(Box, { display: "flex", alignItems: "center" },
        React.createElement(Box, { width: "100%", mr: 1 },
            React.createElement(LinearProgress, __assign({ variant: "determinate" }, otherProps))),
        React.createElement(Box, { minWidth: 35 },
            React.createElement(Typography, { variant: "body2", color: "secondary" }, label))));
};
export default LinearProgressWithLabel;
